interface ScriptCacheProps {
	src: string;
}

interface DployWindow extends Window {
	dploySnippet?: any;
}

export default class ScriptCache {
	src: string;
	isLoaded: boolean;

	constructor(options: ScriptCacheProps) {
		const { src } = options;
		this.src = src;
		this.isLoaded = false;
	}

	loadScript() {
		return new Promise((resolve, reject) => {
			const script = document.createElement("script");
			script.type = "text/javascript";
			script.async = true;
			script.src = `${this.src}`;

			const el = document.getElementsByTagName("script")[0];
			el.parentNode?.insertBefore(script, el);

			script.addEventListener("load", () => {
				this.isLoaded = true;
				resolve(script);
			});

			script.addEventListener("error", () => {
				reject(new Error(`${this.src} failed to load.`));
			});
		});
	}

	load() {
		return new Promise(async (resolve, reject) => {
			await this.loadScript();
			const newWindow: DployWindow = window;
			if (!this.isLoaded) {
				try {
					resolve(newWindow.dploySnippet);
				} catch (e) {
					reject(e);
				}
			} else {
				resolve(newWindow.dploySnippet);
			}
		});
	}
}
